import { render, staticRenderFns } from "./InstallmentLastDayInvoices.vue?vue&type=template&id=08596ad8"
import script from "./InstallmentLastDayInvoices.vue?vue&type=script&lang=js"
export * from "./InstallmentLastDayInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports